import { CDN_CLRSAVE_URL } from '../../constants';

export const COPY_DATA = {
  '19': {
    title: 'ClearTax Tax-Saver Plan',
    subTitle: 'Get the best of both worlds!',
    description:
      'Our Tax-Saver plan is a simple investment plan that’s safe, reliable and most rewarding among all 80C tax-saving instruments!',
    chips: ['Tax-Saving', 'ELSS', 'Growth'],
    lockIn: {
      title: 'Lowest lock-in of just 3 years',
      description:
        'Save tax with lowest lock-in period as compared to FD (5 years) and PPF (15 years)',
    },
    returns: {
      title: 'Maximum returns',
      description: 'Highest returns as compared to other 80C investments',
    },
    note:
      'Note: Every instalment of SIP and every lumpsum order must complete the lock-in period before redemption.',
    investorProfile: {
      userInvested: '35,184',
      userInfo: [
        {
          name: 'Aditya',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559811888_Aditya.png`,
        },
        {
          name: 'Medha',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559811965_Medha.png`,
        },
        {
          name: 'Arvind',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559811925_Arvind.png`,
        },
      ],
    },
  },
  '20': {
    title: 'ClearTax Better than FD Plan',
    subTitle: 'Opt for the safest way to financial security!',
    description:
      'Earn higher returns compared to any Bank FD’s or RD’s. Ideal for shorter 1-3 year investments',
    chips: ['Debt', 'Growth'],
    lockIn: {
      title: 'No lock-in period',
      description: 'Redeem the full amount anytime!',
    },
    returns: {
      title: 'Convenient to use',
      description: 'Simple & effective - Works just like your Bank FD',
    },
    investorProfile: {
      userInvested: '29,483',
      userInfo: [
        {
          name: 'Abhinav Krishna',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559544604_Abhinav-Krishna.png`,
        },
        {
          name: 'Rabi',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559544632_Ankita-kokas.png`,
        },
        {
          name: 'Ankita Kokas',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559544697_Rabi.png`,
        },
      ],
    },
  },
  '21': {
    title: 'Quick Savings',
    subTitle: 'Most convenient & rewarding way to save money!',
    description:
      'Ideal choice to park your money, earning you higher returns compared to any other Savings bank account. Now, save money like a Pro!',
    chips: ['Debt', 'Growth'],
    lockIn: {
      title: 'No lock-in period',
      description: 'Redeem the full amount in 30 minutes!',
    },
    returns: {
      title: 'Convenient to use',
      description:
        'Simple & effective - Works just like your Savings bank account',
    },
    investorProfile: {
      userInvested: '26,862',
      userInfo: [
        {
          name: 'Rabi',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559544632_Ankita-kokas.png`,
        },
        {
          name: 'Ankita Kokas',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559544697_Rabi.png`,
        },
        {
          name: 'Abhinav Krishna',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559544604_Abhinav-Krishna.png`,
        },
      ],
    },
  },
  '22': {
    title: 'ClearTax Grow Rich Plan',
    subTitle: 'Exclusively curated wealth plan by experts!',
    description:
      'Reap rich rewards by investing in our exclusive Grow rich plan and fulfill all your long-term goals',
    chips: ['Equity', 'Growth'],
    lockIn: {
      title: 'No lock-in period',
      description: 'Redeem the full amount anytime!',
    },
    returns: {
      title: 'Minimum Investment. Maximum Returns',
      description: 'Grow wealth, double your investment within 5 years!',
    },
    investorProfile: {
      userInvested: '28,386',
      userInfo: [
        {
          name: 'Ankita Kokas',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559544697_Rabi.png`,
        },
        {
          name: 'Abhinav Krishna',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559544604_Abhinav-Krishna.png`,
        },
        {
          name: 'Rabi',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559544632_Ankita-kokas.png`,
        },
      ],
    },
  },
  '24': {
    title: "Plan your Child's Future",
    subTitle: "Save enough for your Kid's Education or Marriage",
    description:
      'Considering the ever-rising cost of education, this plan is for individuals who want to give their children a bright future. Enable your child to pursue his/ her dream without having to worry about the associated huge expenses.',
    chips: ['Equity', 'Balanced', 'Growth'],
    lockIn: {
      title: 'No lock-in period',
      description: 'Redeem the full amount anytime!',
    },
    returns: {
      title: 'Stable long-term returns',
      description:
        'Monthly SIP investments can build a large wealth corpus in 5 years or more',
    },
    investorProfile: {
      userInvested: '29,483',
      userInfo: [
        {
          name: 'Abhinav Krishna',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559544604_Abhinav-Krishna.png`,
        },
        {
          name: 'Rabi',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559544632_Ankita-kokas.png`,
        },
        {
          name: 'Ankita Kokas',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559544697_Rabi.png`,
        },
      ],
    },
  },
  '25': {
    title: 'ClearTax Balanced Growth Plan',
    subTitle: 'Lower risk but Higher rewards!',
    description:
      'Ideal investment choice for realizing Mid-size goals like Car, Vacations etc.',
    chips: ['Balanced', 'Growth'],
    lockIn: {
      title: 'No lock-in period',
      description: 'Redeem the full amount anytime!',
    },
    returns: {
      title: 'Minimum Investment. Maximum Returns',
      description: 'Grow wealth, double your investment within 5 years!',
    },
    investorProfile: {
      userInvested: '23,184',
      userInfo: [
        {
          name: 'Aditya',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1564484439_img1.png`,
        },
        {
          name: 'Sathish',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1564484465_img2.png`,
        },
        {
          name: 'Rahul',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1564484490_img3.png`,
        },
      ],
    },
  },
  '26': {
    title: 'ClearTax Aggressive Grow Wealth Plan',
    subTitle: 'Smart, Reliable, and Rewarding Plan',
    description:
      'Double your invested money in almost 5 years with our exclusive aggressive Grow Wealth Plan',
    chips: ['Equity', 'Growth'],
    lockIn: {
      title: 'No lock-in period',
      description: 'Redeem the full amount anytime!',
    },
    returns: {
      title: 'Minimum Investment. Maximum Returns',
      description: 'Grow wealth, double your investment within 5 years!',
    },
    investorProfile: {
      userInvested: '26,981',
      userInfo: [
        {
          name: 'Rabi',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559544632_Ankita-kokas.png`,
        },
        {
          name: 'Abhinav Krishna',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559544604_Abhinav-Krishna.png`,
        },
        {
          name: 'Ankita Kokas',
          imgURL: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1559544697_Rabi.png`,
        },
      ],
    },
  },
};



// WEBPACK FOOTER //
// ./constants/plan/copyData.ts